import { ROLES } from "./constants";

// Permission-based landing routes after login. Roles for phases that don't have a
// dedicated workspace yet (scheduling, payroll review) fall back to the management
// dashboard rather than a broken link.
const ROLE_LANDING_ROUTES = {
  [ROLES.ONBOARDING_MANAGER]: "/management/onboarding",
};

export function getLandingRouteForUser(user) {
  if (!user) return "/staff/login";
  if (user.active_portal === "STAFF") return "/employee";
  return ROLE_LANDING_ROUTES[user.role] || "/management";
}
